'use client';

import { useRouter, usePathname } from 'next/navigation';

import { Icon } from '@/elements/icon/icon.component';
import { MediaImage } from '@/elements/media-image/media-image.component';
import {
  Container,
  ImageWrap,
  Info,
  Heading,
  Name,
  Qualifications,
  Biography,
} from './lecturer.elements';

import { IconArrowNarrowRight } from '@tabler/icons-react';

const Lecturer = ({
  lecturer: {
    slug,
    firstName,
    lastName,
    biographies,
    bio,
    qualifications,
    profileImage,
    memberBiography,
  },
  primary,
  teamMember,
  unabridged,
}) => {
  const router = useRouter();
  const pathname = usePathname();

  return (
    <Container
      onClick={() =>
        !teamMember && !pathname.includes(slug) ? router.push(`/predavaci/${slug}`) : null
      }
      $clickable={teamMember || pathname.includes(slug)}
    >
      <ImageWrap>
        <MediaImage
          variant="lecturer"
          src={profileImage?.sizes?.bigSquare?.url}
          width={256}
          height={256}
          alt={profileImage?.alt || `${firstName} ${lastName}`}
          style={{ objectFit: 'cover', maxWidth: '100%', height: 'auto' }}
        />
      </ImageWrap>
      <Info>
        <Heading>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Name $bigger>{`${firstName} ${lastName}`}</Name>
            {qualifications ? <Qualifications>{qualifications}</Qualifications> : ''}
          </div>
          {!teamMember && !pathname.includes(slug) ? (
            <div className="arrow">
              <Icon color="blue">
                <IconArrowNarrowRight />
              </Icon>
            </div>
          ) : null}
        </Heading>
        <Biography $unabridged={unabridged}>
          {teamMember
            ? memberBiography
            : primary
              ? biographies[0]?.biography
              : bio
                ? biographies.find((biography) => biography.id === bio)?.biography
                : ''}
        </Biography>
      </Info>
    </Container>
  );
};

export { Lecturer };
